import React, { useState, useEffect } from "react";
import PokemonImage from "./PokemonImage";
import ButtonRectangle from "./ButtonRectangle";

import { DetailsMesures } from "./DetailsMesures";
import { Ranking } from "./Ranking";
import usePokemonData from "../utils/usePokemonData";
import Stats from "./Stats";
import { IconQuestionMark, IconX } from "@tabler/icons-react";
import useEvolutionChain from "../utils/useEvolutionChain";
import usePokemons from "../utils/usePokemons";
import Thumbnail from "./Thumbnail";
export const PokemonDetailsCard = ({
  mainDetailsURL,
  idMain,
  cleanMainURL,
}) => {
  const secondary = mainDetailsURL?.species?.url;
  const detailsSecondaryURL = usePokemonData(secondary);
  const colorOutcome = "red";
  // const [evolutions, setEvolutions] = useState([]);
  const nameEvolutions = mainDetailsURL?.name;
  const messageEvolution = "No further evolution";
  const { evolutionData } = useEvolutionChain(nameEvolutions);
  const basePokemon = evolutionData?.chain?.species?.name || messageEvolution;
  const firstEvol = evolutionData?.chain?.species?.name || messageEvolution;
  const secondEvol =
    evolutionData?.chain?.evolves_to[0]?.species?.name || messageEvolution;

  const thirdEvolution =
    evolutionData?.chain?.evolves_to?.[0]?.evolves_to?.[0]?.species?.name ||
    messageEvolution;
  const [totalStats, setTotalStats] = useState(0);
  const { pokemonsUtils: allPokemonsToEvolutions } = usePokemons();
  useEffect(() => {
    if (mainDetailsURL?.stats) {
      // Usamos reduce para sumar todos los base_stat
      const total = mainDetailsURL.stats.reduce(
        (sum, stat) => sum + stat.base_stat,
        0
      );
      setTotalStats(total);
    }
  }, [mainDetailsURL]); // Se ejecuta cuando mainDetailsURL cambia

  const filterBase = basePokemon
    ? allPokemonsToEvolutions?.filter((pokemon) =>
        pokemon.name.includes(basePokemon.toLowerCase())
      )
    : "no pokemon found";

  const pokemonDataAccesImagen = usePokemonData(filterBase[0]?.url);
  const imageBase =
    pokemonDataAccesImagen?.sprites?.versions?.["generation-v"]?.["black-white"]
      ?.front_default || pokemonDataAccesImagen?.sprites?.front_default;
  if (!imageBase) {
    return;
  } else {
    console.log(imageBase);
  }
  /* A esta url es a la que se hace fetch para acceder a resultadoFetch.sprites.front_shiny, es la imagen */

  return (
    <div className="mainPokemon-card">
      {/* tabler icon */}
      {/* imagen render de pokemon  */}

      <div className="closeDetails-x" onClick={cleanMainURL}>
        <IconX />
      </div>
      <div className="pokeImagen-main">
        <PokemonImage
          src={
            mainDetailsURL?.sprites?.versions?.["generation-v"]?.[
              "black-white"
            ]?.["animated"]?.front_default ||
            pokemonDataAccesImagen?.sprites?.front_default
          }
          alt="pokemon selected"
        />
      </div>
      <div id="flex-container-des">
        <p id="numberID">
          {mainDetailsURL?.id ? `#${mainDetailsURL?.id}` : "# Guess"}
        </p>
        <h2>{mainDetailsURL?.name?.toUpperCase()}.</h2>

        <p>{mainDetailsURL?.name}</p>
      </div>
      <div className="main-elements">
        <div id="abilities-container">
          <h3>ABILITIES</h3>
          <div className="abilities">
            {/* Verifica si types existe antes de mapear */}
            {mainDetailsURL?.types?.length > 0 ? (
              mainDetailsURL.types.map((type, index) => (
                <ButtonRectangle
                  newColorButton={" #af7ac5 "}
                  key={index}
                  complementaryText={type.type.name}
                />
              ))
            ) : (
              <p>
                "Curious about its abilities? Click the button to find out!"🌀
              </p>
            )}
          </div>
        </div>
      </div>
      <div style={{ maxWidth: "100%", padding: "1rem", textAlign: "center" }}>
        <p
          style={{
            textAlign: "center",
            fontWeight: "bold",
            margin: ".5rem .2rem",
          }}
        >
          POKEDEX ENTRY
        </p>
        <div
          style={{
            letterSpacing: "0.2px",
            hyphens: "auto",
            margin: ".7rem .2rem",
          }}
        >
          <p>
            {detailsSecondaryURL?.flavor_text_entries[0]?.flavor_text ||
              "Discover something awesome about this Pokémon!💗 Click the details button to learn more!"}
          </p>
        </div>
      </div>
      <DetailsMesures
        heightPokemon={mainDetailsURL?.height}
        weigthPokemon={mainDetailsURL?.weight}
      />
      <Ranking baseExperience={mainDetailsURL?.base_experience} />
      <div id="stats">
        <h4 style={{ margin: "0 0 1rem" }}>Stats</h4>
        <div className="rendered-stats">
          {mainDetailsURL?.stats ? (
            mainDetailsURL?.stats?.map((stat, index) => {
              return (
                <Stats
                  key={index}
                  name={stat.stat.name}
                  base={stat.base_stat}
                />
              );
            })
          ) : (
            <div className="lockStats">
              <p>
                🔍 "Discover how powerful this Pokémon is! Hit the stats
                button!"
              </p>
            </div>
          )}
          {mainDetailsURL?.stats ? (
            <Stats colorOutcome={colorOutcome} name={"rs"} base={totalStats} />
          ) : (
            ""
          )}
        </div>
      </div>
      <div id="evolutions">
        <h3 style={{ margin: "0" }}>Evolutions:</h3>
        {evolutionData ? (
          <div className="rendered-evolutions">
            {/* <img
              alt="imagen-referencia"
              className="single-pok-evolution"
              src={contact-form-container
                pokemonDataAccesImagen?.sprites?.versions?.["generation-v"]?.[
                  "black-white"
                ]?.front_default
              }
              title={titleBase}
            /> */}
            <Thumbnail name={firstEvol} />

            <Thumbnail name={secondEvol} />

            <Thumbnail name={thirdEvolution} />
          </div>
        ) : (
          // evolutions.length  0 ? (
          //   <div className="rendered-evolutions">
          //     <PokemonImage
          //       src={
          //         "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/10.png"
          //       }
          //     />
          //     <PokemonImage
          //       src={
          //         "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/10.png"
          //       }
          //     />
          //     <PokemonImage
          //       src={
          //         "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/10.png"
          //       }
          //     />
          //   </div>
          // )

          <div className="rendered-evolutions">
            <div id="evol">
              <IconQuestionMark className="iconEvol" />
            </div>

            <div id="evol">
              <IconQuestionMark className="iconEvol" />
            </div>

            <div id="evol">
              <IconQuestionMark className="iconEvol" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PokemonDetailsCard;
/* Esta carta contiene detalle de la información del pokemon */
